analytics.eventConfig.push({
    "target": ".contentCard_section",
    "events": [
        {
            "eventTarget": ".contentCard_content .contentCard_copy a",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'contentCards',
                'interactionType': 'click',
                'elementClicked': "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".contentCard_content .cta-button a",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'contentCards',
                'interactionType': 'click',
                'elementClicked': "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".contentCard_content .cta-button-popup-modal a",
            "eventType": "click",
            "tags": {
                "event": "componentInteraction",
                'componentType': 'contentCards',
                'interactionType': 'click',
                'elementClicked': "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        },
        {
            "eventTarget": ".heading-section a",
            "eventType": "click",
            "tags": {
                'event': 'componentInteraction',
                'componentType': 'contentCards',
                'interactionType': 'click',
                'elementClicked': "link",
                'contentTitle': '',
                'destinationURL': '',
                'deviceType': ''
            }
        }
    ]

});